
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { TimerButton } from "@/components/TimerButton";

interface DayCompletedScreenProps {
  currentDayIndex: number;
  onContinue: () => void;
  isAdmin: boolean;
}

export function DayCompletedScreen({ 
  currentDayIndex, 
  onContinue,
  isAdmin 
}: DayCompletedScreenProps) {
  // Calculate 20 hours in seconds: 20 hours * 60 minutes * 60 seconds
  const TWENTY_HOURS_IN_SECONDS = 20 * 60 * 60; // 72000 seconds
  
  // Only show timer for days 0 (first day) and 1 (second day)
  const shouldShowTimer = currentDayIndex < 2;
  
  return (
    <motion.div
      key="day-completed"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className="text-center py-10 space-y-6"
    >
      <div className="mx-auto bg-green-50 w-16 h-16 rounded-full flex items-center justify-center">
        <CheckCircle className="h-8 w-8 text-green-500" />
      </div>
      <h2 className="text-2xl font-semibold">Day {currentDayIndex + 1} Completed!</h2>
      <p className="text-slate-600 max-w-md mx-auto">
        Great job! You've completed the tasks for today.
        <br />
        {shouldShowTimer ? 
          "Please come back tomorrow to continue the warm-up process." : 
          "You can now continue to the next step!"}
      </p>
      
      {isAdmin ? (
        <Button onClick={onContinue} className="mt-4">
          Continue to Next Day
        </Button>
      ) : (
        <div className="mt-6">
          {shouldShowTimer ? (
            <TimerButton 
              onClick={onContinue} 
              timerSeconds={TWENTY_HOURS_IN_SECONDS}
              className="mx-auto"
            >
              Continue to Day {currentDayIndex + 2}
            </TimerButton>
          ) : (
            <Button onClick={onContinue} className="mx-auto">
              Continue to Next Step
            </Button>
          )}
        </div>
      )}
    </motion.div>
  );
}
